import { all, put, takeEvery } from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import Auth from '@aws-amplify/auth';
import Storage from '@aws-amplify/storage';
import vehicleDefaults from 'domain/vehicleDefaults.json';
import { exception } from 'circe/logger';
import { authClient, operatorClient, onboardingClient } from 'domain/HttpClients';
import { morphFormAddressToRequestPayload } from 'domain/batch/sheets/utils';
import moment from 'moment';
import uuid from 'uuid/v4';
import { FORM_NAME, SUCCESS_MESSAGE } from 'domain/carriers/components/create/constants';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { getTokens } from 'domain/carriers/components/create/model';

import { ROUTES as CARRIERS_ROUTES } from 'domain/carriers/constants';

function* signupFunction(context, action) {
  if (action.payload.name !== FORM_NAME) return;

  yield put(startSubmit(FORM_NAME));

  const {
    payload: { values },
  } = action;

  const {
    firstName,
    lastName,
    email,
    password,
    phone,
    companyCode,
    company,
    id,
    key,
    clientId,
    companyMoi,
    agent,
  } = values;
  try {
    if (companyCode) {
      const resp = yield operatorClient
        .Get(`/public-api/company/token/${encodeURIComponent(companyCode)}/validate`)
        .send();

      if (resp) {
        throw new Error('companyCodeExist');
      }
    }
    const name = `${firstName} ${lastName}`;
    yield put(startSubmit(FORM_NAME));
    // cognito sign up
    try {
      const response = yield Auth.signUp({
        username: email,
        password,
        attributes: {
          name,
          email,
          'custom:companyCode': companyCode || '',
          'custom:company': company || `${name}'s Company`,
          'custom:isIndividual': '0',
          'custom:defaultCountry': 'SA',
        },
        validationData: [], // optional
      });
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    }
    // cognito login
    const tokens = yield login({ email, password });
    // do auth calls
    const postData = {
      email,
      phone,
      firstName,
      accountType: 'COURIER',
      lastName,
      defaultCountry: 'SA',
      address: 'My address',
      bayanAccountConfig: {
        id,
        key,
        clientId,
        companyMoi,
        agent,
      },
    };
    const headers = {
      Authorization: `Bearer ${tokens.idToken}`,
    };

    try {
      yield authClient
        .Post('/api/self')
        .withData(postData)
        .withHeaders(headers)
        .send();

      const accountData = {
        address: 'Address',
        bankName: 'Bank Name',
        iban: 'iBanNumber',
        name: company || `${name}'s Company`,
        accountType: 'COURIER',
        companyCode,
        phone,
        defaultCountry: 'SA',
        domain: SYSTEM_DOMAIN,
        bayanAccountConfig: {
          id,
          key,
          clientId,
          companyMoi,
          agent,
        },
      };

      yield authClient
        .Post('/api/self/accounts')
        .withData(accountData)
        .withHeaders(headers)
        .send();

      yield put(stopSubmit(FORM_NAME));
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    }

    yield put(reset(FORM_NAME));
    yield put(showNotification(SUCCESS_MESSAGE, 'success'));
    setTimeout(() => {
      context.history.push(CARRIERS_ROUTES.ROOT);
    }, 2000);
  } catch (e) {
    console.error(e);
    yield put(showNotification(e.message, 'error'));
    yield put(stopSubmit(FORM_NAME));
  }
}
function* login({ email, password }) {
  try {
    const data = {
      clientId: AWS_USER_POOL_WEB_CLIENT_ID,
      domain: SYSTEM_DOMAIN,
      password,
      username: email,
    };
    const resp = yield authClient
      .Post('/public-api/user-admin/signin')
      .withData(data)
      .send();

    const tokens = getTokens(resp);

    return tokens;
  } catch (e) {
    throw new Error(e.message);
  }
}
function* watcher(context) {
  yield all([takeEvery(doSubmit().type, signupFunction, context)]);
}

export default watcher;
